import { dateToArray, parseDate } from "../components/Utils";
import { AdditionalField } from "./AdditionalField";

export class GeneralConfig {
  targetDate: Date = new Date();
  targetDateEnd?: Date;
  registerStart: Date = new Date();
  registerEnd: Date = new Date();
  maxTotalAttendeesCount: number = 0;
  maxCountInfo: number = 0;
  maxCountWorkshop: number = 0;
  minCountInfo: number = 0;
  minCountWorkshop: number = 0;
  titleMessage: string = '';
  bookingMessage: string = '';
  applicationSuccessfulMessage: string = '';
  beforeRegisterStartMessage: string = '';
  afterRegisterEndMessage: string = '';
  bookedUpMessage: string = '';
  attendeeCount: number = 0;
  applicationTitle: string = 'Mini-Book';
  workshopName?: string;
  infoName?: string;
  breakName?: string;
  privacyPolicyText: string = '';
  privacyPolicyUrl: string = '';
  splitApplicationForm: boolean = false;
  showTypeInTable: boolean = false;
  showSalutationField: boolean = false;
  additionalFields: AdditionalField[] = [];
  groupedByOptions: string[][] = [];

  public static createFromJson(input: any): GeneralConfig {
    const data = new GeneralConfig;
    data.fromJson(input);
    return data;
  }

  fromJson(input: any) {
    this.targetDate = parseDate(input['targetDate']);
    if (input['targetDateEnd'] != null) {
      this.targetDateEnd = parseDate(input['targetDateEnd']);
    }
    this.registerStart = parseDate(input['registerStart']);
    this.registerEnd = parseDate(input['registerEnd']);
    this.maxTotalAttendeesCount = input['maxTotalAttendeesCount'];
    this.maxCountInfo = input['maxCountInfo'];
    this.maxCountWorkshop = input['maxCountWorkshop'];
    this.minCountInfo = input['minCountInfo'];
    this.minCountWorkshop = input['minCountWorkshop'];
    this.titleMessage = input['titleMessage'];
    this.bookingMessage = input['bookingMessage'];
    this.applicationSuccessfulMessage = input['applicationSuccessfulMessage'];
    this.beforeRegisterStartMessage = input['beforeRegisterStartMessage'];
    this.afterRegisterEndMessage = input['afterRegisterEndMessage'];
    this.bookedUpMessage = input['bookedUpMessage'];
    this.attendeeCount = input['attendeeCount'];
    this.applicationTitle = input['applicationTitle'];
    this.workshopName = input['workshopName'];
    this.infoName = input['infoName'];
    this.breakName = input['breakName'];
    this.privacyPolicyText = input['privacyPolicyText'];
    this.privacyPolicyUrl = input['privacyPolicyUrl'];
    this.splitApplicationForm = input['splitApplicationForm'];
    this.showTypeInTable = input['showTypeInTable'];
    this.showSalutationField = input['showSalutationField'];
    if (input['additionalFields']) {
      for (const child of input['additionalFields']) {
        this.additionalFields.push(AdditionalField.createFromJson(child));
      }
    }
    if (input['groupedByOptions']) {
      for (const child of input['groupedByOptions']) {
        this.groupedByOptions.push(child);
      }
    }
  }

  toJson(): any {
    return {
      targetDate: dateToArray(this.targetDate),
      targetDateEnd: this.targetDateEnd ? dateToArray(this.targetDateEnd) : undefined,
      registerStart: dateToArray(this.registerStart),
      registerEnd: dateToArray(this.registerEnd),
      maxTotalAttendeesCount: this.maxTotalAttendeesCount,
      maxCountInfo: this.maxCountInfo,
      maxCountWorkshop: this.maxCountWorkshop,
      minCountInfo: this.minCountInfo,
      minCountWorkshop: this.minCountWorkshop,
      titleMessage: this.titleMessage,
      bookingMessage: this.bookingMessage,
      applicationSuccessfulMessage: this.applicationSuccessfulMessage,
      beforeRegisterStartMessage: this.beforeRegisterStartMessage,
      afterRegisterEndMessage: this.afterRegisterEndMessage,
      bookedUpMessage: this.bookedUpMessage,
      privacyPolicyText: this.privacyPolicyText,
      privacyPolicyUrl: this.privacyPolicyUrl,
      splitApplicationForm: this.splitApplicationForm,
      showTypeInTable: this.showTypeInTable,
      showSalutationField: this.showSalutationField,
    };
  }
}
